import { listen, qs, qsa } from "@fluorescent/dom";

import { section } from "@/glow";

section("cart", {
  onLoad() {
    const { enableCartAjax } = this.container.dataset;
    const ajaxEnabled = enableCartAjax === "true";
    this.form = qs("[data-form]", this.container);

    if (!this.form) return;
    const buttons = qsa("[data-change]", this.container);
    const quantityInput = qs("[data-quantity-input]", this.container);

    this.timer;

    this.events = [
      listen(buttons, "click", e => {
        e.preventDefault();
        const { change } = e.currentTarget.dataset;
        const input = qs("input", e.currentTarget.parentNode);

        if (change === "increment") {
          input.value >= 0 && input.value++;
        } else if (change === "decrement") {
          input.value > 0 && input.value--;
        }

        if (ajaxEnabled) this.handleTimeout();
      }),
    ];

    if (ajaxEnabled) {
      this.events.push(listen(quantityInput, "input", this.handleTimeout));
    }
  },

  handleTimeout() {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.form.submit();
    }, 1000);
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
  },
});
